import Vue from 'vue';
import EventsMatching from '@/components/sports/EventsMatching';

export default Vue.extend({
  name: 'eventsMatching',
  render() {
    return <EventsMatching />;
  },
});
